var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPersonalInfo = function SvgPersonalInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.455 21.616a2.875 2.875 0 0 1 4.014-.115 2.875 2.875 0 0 1-.115 4.013c-1.101 1.104-5.94 2.04-5.94 2.04s.94-4.836 2.041-5.938ZM20.912 11.96l4.549-4.549a1.837 1.837 0 0 1 2.599 0l1.3 1.3",
    stroke: "#F39237",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.963 19.108 29.36 8.71a2.764 2.764 0 0 1 3.9 0v0a2.766 2.766 0 0 1 0 3.9L22.861 23.005l-3.9-3.898ZM25.46 12.61l3.9 3.899",
    stroke: "#F39237",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.525 21.875c0 5.051.53 7.906-2.198 10.635l-1.415 1.414a.473.473 0 0 1-.332.136H6.406a.47.47 0 0 1-.331-.8l.75-.75c2.83-2.831 2.2-4.642 2.2-19.717 0-3.935 2.935-6.043 3.75-6.858h5.56",
    stroke: "#F39237",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgPersonalInfo;